/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { Icon, Typography } from '@statsbomb/kitbag-components';
import { ErrorPageContent, ErrorPageWrapper } from './ErrorPage.styles';
import ExternalLink from '../ExternalLink/ExternalLink';
import { currentLocationRV } from '../../apollo';
import uiStructure from '../../apollo/uiStructure';
import { PAGE } from '../app/index.constants';

const ErrorPage = () => {
  let hasContextFilters = false;
  const currentLocation = currentLocationRV();
  const { DEFAULT, WITH_CONTEXT_FILTERS } = PAGE;

  uiStructure.pages.forEach((page) => {
    page.path.forEach((url) => {
      if (new RegExp(url, 'g').test(currentLocation)) {
        hasContextFilters = page.contextFilters;
      }
    });
  });

  return (
    <ErrorPageWrapper
      $top={hasContextFilters ? WITH_CONTEXT_FILTERS.top : DEFAULT.top}
    >
      <ErrorPageContent>
        <Icon variant="Warning" colour="messaging.warning" />
        <Typography variant="headingLarge" data-testid="error-header">
          Unable to Load Content
        </Typography>
        <Typography variant="bodyRegular">
          Try refreshing the page. If the problem persists,{' '}
          <ExternalLink href={process.env.SUPPORT_URL}>
            contact support
          </ExternalLink>
          .
        </Typography>
      </ErrorPageContent>
    </ErrorPageWrapper>
  );
};

export default ErrorPage;
